export type SensorIdentifierLike = {
  productSn?: unknown;
  sn?: unknown;
};

export function extractSensorIdentifiers(
  metadata: SensorIdentifierLike | undefined | null
): { productSn?: string; sn?: string } {
  return {
    productSn:
      typeof metadata?.productSn === 'string' ? metadata.productSn : undefined,
    sn: typeof metadata?.sn === 'string' ? metadata.sn : undefined,
  };
}

export function sensorMatchesId(
  metadata: SensorIdentifierLike | undefined,
  sensorId: string
): boolean {
  const { productSn, sn } = extractSensorIdentifiers(metadata);
  return productSn === sensorId || sn === sensorId;
}

export function resolveSensorKey(
  metadata: SensorIdentifierLike | undefined,
  fallback = 'unknown'
): string {
  const { productSn, sn } = extractSensorIdentifiers(metadata);
  return productSn ?? sn ?? fallback;
}

export function addSensorIdentifiersToSet(
  set: Set<string>,
  metadata: SensorIdentifierLike | undefined
): void {
  const { productSn, sn } = extractSensorIdentifiers(metadata);
  if (typeof productSn === 'string' && productSn.length > 0) {
    set.add(productSn);
  }
  if (typeof sn === 'string' && sn.length > 0) {
    set.add(sn);
  }
}
